import axios from "axios";
import settings from "utils/settings";

const apiUrl = `${settings.apiUrl}api/`;

const controllerUrl = `${apiUrl}bonus`;

export const requestTypes = () =>
  axios.get(`${controllerUrl}/types`);

export const requestAdd = (data) =>
  axios.post(`${controllerUrl}`, data);

export const requestUpdate = (id, data) =>
  axios.put(`${controllerUrl}/${id}`, data);

export const requestDelete = (id) =>
  axios.delete(`${controllerUrl}/${id}`);

export const requestList = (criteria) =>
  axios.post(`${controllerUrl}/list`, {
    criteria
  });



// WEBPACK FOOTER //
// ./src/actions/festive-days/requests.js